import {
  IconAward,
  IconBan,
  IconBrandDiscord,
  IconCalendarWeek,
  IconClipboardData,
  IconCubeSend,
  IconFileCheck,
  IconGift,
  IconHome,
  IconList,
  IconMessages,
  IconNetwork,
  IconNews,
  IconReport,
  IconServer,
  IconShoppingBag,
  IconSlideshow,
  IconUsers,
  IconWallet,
} from '@tabler/icons-react';
import { ROLE } from '@/shared/const/roles';

export const links = [
  { link: '/dashboard', label: 'Home', icon: IconHome, role: ROLE.SUPPORT },
  { link: '/dashboard/payments', label: 'Payments', icon: IconWallet, role: ROLE.GAME_MASTER },
  { link: '/dashboard/mmotop', label: 'MMO TOP', icon: IconAward, role: ROLE.SUPPORT },
  { link: '/dashboard/support', label: 'Support', icon: IconMessages, role: ROLE.SUPPORT },
  {
    link: '/dashboard/discord',
    label: 'Discord Bot',
    icon: IconBrandDiscord,
    role: ROLE.CONTENT_MANAGER,
  },
  { link: '/dashboard/news', label: 'News', icon: IconNews, role: ROLE.CONTENT_MANAGER },
  {
    link: '/dashboard/slides',
    label: 'Launcher Slides',
    icon: IconSlideshow,
    role: ROLE.CONTENT_MANAGER,
  },
  { link: '/dashboard/servers', label: 'Servers', icon: IconServer, role: ROLE.GAME_MASTER },
  {
    link: '/dashboard/maintenance',
    label: 'Maintenance',
    icon: IconCalendarWeek,
    role: ROLE.GAME_MASTER,
  },
  { link: '/dashboard/users', label: 'Users', icon: IconUsers, role: ROLE.GAME_MASTER },
  { link: '/dashboard/online', label: 'Online Users', icon: IconNetwork, role: ROLE.GAME_MASTER },
  { link: '/dashboard/logs', label: 'Logs', icon: IconFileCheck, role: ROLE.GAME_MASTER },
  { link: '/dashboard/bans', label: 'Bans', icon: IconBan, role: ROLE.GAME_MASTER },
  { link: '/dashboard/osid_bans', label: 'OS ID Bans', icon: IconBan, role: ROLE.GAME_MASTER },
  {
    link: '/dashboard/shop/categories',
    label: 'Shop Categories',
    icon: IconList,
    role: ROLE.GAME_MASTER,
  },
  {
    link: '/dashboard/shop/goods',
    label: 'Shop Goods',
    icon: IconShoppingBag,
    role: ROLE.GAME_MASTER,
  },
  { link: '/dashboard/promo', label: 'Promo System', icon: IconGift, role: ROLE.ADMIN },
  { link: '/dashboard/send', label: 'Send Items', icon: IconCubeSend, role: ROLE.ADMIN },
  {
    link: '/dashboard/sentList',
    label: 'Sent Items List',
    icon: IconClipboardData,
    role: ROLE.GAME_MASTER,
  },
  {
    link: '/dashboard/reports',
    label: 'Cheater Reports',
    icon: IconReport,
    role: ROLE.GAME_MASTER,
  },
];
